export default "/build/images/head.png?a1578c7e2c06e16c6be5173598fce881";